<template>
  <header class="header">
    <div class="header__item header__burger-wrap">
      <div class="button-burger" :class="menuActiveMobile ? 'active' : ''" @click="toggleMainMenu">
        <span class="button-burger__line"></span>
        <span class="button-burger__line"></span>
        <span class="button-burger__line"></span>
      </div>
    </div>
    <div class="header__item error__report" @click="appealModal = true">
      <svg width="25" height="25" viewBox="0 0 25 25" fill="none" xmlns="http://www.w3.org/2000/svg" style="margin-right: 9px">
      <mask id="path-1-inside-1_3319_18" fill="white">
      <path fill-rule="evenodd" clip-rule="evenodd" d="M3 0C1.34315 0 0 1.34315 0 3V17C0 18.6569 1.34315 20 3 20H13.125L20 25V20H22C23.6569 20 25 18.6569 25 17V3C25 1.34315 23.6569 0 22 0H3Z"/>
      </mask>
      <path d="M13.125 20L13.7132 19.1913L13.4502 19H13.125V20ZM20 25L19.4118 25.8087L21 26.9638V25H20ZM20 20V19H19V20H20ZM1 3C1 1.89543 1.89543 1 3 1V-1C0.790861 -1 -1 0.79086 -1 3H1ZM1 17V3H-1V17H1ZM3 19C1.89543 19 1 18.1046 1 17H-1C-1 19.2091 0.790861 21 3 21V19ZM13.125 19H3V21H13.125V19ZM20.5882 24.1913L13.7132 19.1913L12.5368 20.8087L19.4118 25.8087L20.5882 24.1913ZM19 20V25H21V20H19ZM22 19H20V21H22V19ZM24 17C24 18.1046 23.1046 19 22 19V21C24.2091 21 26 19.2091 26 17H24ZM24 3V17H26V3H24ZM22 1C23.1046 1 24 1.89543 24 3H26C26 0.790861 24.2091 -1 22 -1V1ZM3 1H22V-1H3V1Z" fill="#F67759" mask="url(#path-1-inside-1_3319_18)"/>
      <path d="M6 6H12" stroke="#F67759"/>
      <path d="M6 10H19" stroke="#F67759"/>
      <path d="M6 14H19" stroke="#F67759"/>
      </svg>
      Предложения/Обращения
    </div>
    <div class="header__item error__report" @click="reportModal = true">
      <svg width="25" height="25" viewBox="0 0 25 25" fill="none" xmlns="http://www.w3.org/2000/svg" style="margin-right: 9px">
        <circle cx="12.5" cy="12.5" r="12" stroke="#C01082"/>
        <path d="M13.884 6L13.5525 13.4028H11.4309L11.0994 6H13.884ZM12.4917 14.9408C12.9116 14.9408 13.2652 15.093 13.5525 15.3972C13.8508 15.6901 14 16.0451 14 16.462C14 16.8901 13.8508 17.2563 13.5525 17.5606C13.2652 17.8535 12.9116 18 12.4917 18C12.0829 18 11.7293 17.8535 11.4309 17.5606C11.1436 17.2563 11 16.8901 11 16.462C11 16.0451 11.1436 15.6901 11.4309 15.3972C11.7293 15.093 12.0829 14.9408 12.4917 14.9408Z" fill="#C01082"/>
      </svg>
      Сообщить об ошибке
    </div>
    <div class="header__item">
      <div class="user-info" @click.prevent.stop="onClick">
        <div class="user-avatar user-info__avatar">
          <img v-if="currentUserData.avatar !== null" :src="currentUserData.avatar" :alt="currentUserData.full_name">
          <img v-else src="/img/avatar-thumb.png" :alt="currentUserData.full_name">
        </div>
        <div class="user-info__username">{{ currentUserData.full_name }}</div>
        <div class="drop-icon user-info__icon" :class="currentUserData.menu.is_active ? 'drop-icon_active' : ''">
          <svg class="dropdown-icon" viewBox="0 0 12 8" fill="none" xmlns="http://www.w3.org/2000/svg">
            <path d="M1 1L6 6L11 1" stroke="currentColor" stroke-width="2"/>
          </svg>
        </div>
        <transition name="fade">
          <div v-if="currentUserData.menu.is_active"
               class="user-info__popup-menu">
            <AppHeaderPopup @log-out="logOut"/>
          </div>
        </transition>
      </div>
    </div>
    <div class="header__item header__mobile-menu-list">
      <AppAsideMenuList v-if="mediaBreakpoint !== 'desktop'"
                        :notification-widget-active="notificationWidgetActive"
                        :notification-counter="notificationCounter"
                        :dialog-widget-active="dialogWidgetActive"
                        :dialog-counter="dialogCounter"
                        @toggle-notification-widget="toggleNotificationWidget"
                        @toggle-dialog-widget="toggleDialogWidget"
      />
    </div>

    <ErrorReportModal v-if="reportModal" @close="reportModal = false" />
    <ErrorAppealModal v-if="appealModal" @close="appealModal = false" />
    
  </header>
</template>

<script>
import AppHeaderPopup from './AppHeaderPopup.vue'
import AppAsideMenuList from '@/components/aside/AppAsideMenuList'
import ErrorReportModal from '@/components/page/modal/ErrorReportModal.vue'
import ErrorAppealModal from '@/components/page/modal/ErrorAppealModal.vue'

export default {
  name: 'AppHeader',
  components: {
    AppAsideMenuList,
    AppHeaderPopup,
    ErrorReportModal,
    ErrorAppealModal
  },
  data () {
    return {
      reportModal: false,
      appealModal: false
    }
  },
  computed: {
    menuActiveMobile () {
      return this.$store.getters.mainMenu.is_active_mobile
    },
    notificationWidgetActive () {
      return this.$store.getters.getNotificationWidgetActive
    },
    notificationCounter () {
      return this.$store.getters.getNewNotificationCounter
    },
    dialogWidgetActive () {
      return this.$store.getters.getDialogWidgetActive
    },
    dialogCounter () {
      return this.$store.getters.getNewDialogCounter
    },
    mediaBreakpoint () {
      return this.$store.getters.getMediaBreakpoint
    },
    currentUserData () {
      return this.$store.getters.currentUserData
    }
  },
  methods: {
    toggleMainMenu () {
      this.$store.commit('TOGGLE_MAIN_MENU_MOBILE')
    },
    toggleNotificationWidget () {
      this.$store.dispatch('toggleNotificationWidget')
    },
    toggleDialogWidget () {
      this.$store.dispatch('toggleDialogWidget')
    },
    onClick () {
      this.$store.dispatch('toggleHeaderMenu')
    },
    logOut () {
      this.$emit('log-out')
    }
  }
}
</script>

<style lang="scss" scoped>
@import '../../assets/css/system/_vars';
@import '../../assets/css/system/_mixins';

.header {
  position: relative;
  z-index: 1000;
  width: 100%;
  padding: 10px 90px 10px 290px;
  display: flex;
  flex-flow: row nowrap;
  justify-content: flex-end;
  align-items: center;
  height: $header_height;
  border-bottom: 3px solid $color_second-border2;

  &__item {
    @media screen and (max-width: $tablet_start) {
      margin-right: 10px;

      &:last-child {
        margin-right: 0;
      }
    }
  }

  &__burger-wrap {
    margin-right: auto;
    display: none;

    @media screen and (max-width: $tablet_start) {
      display: block;
    }
  }

  &__mobile-menu-list {
    display: none;
    height: 100%;

    @media screen and (max-width: $tablet_start) {
      display: block;
    }
  }

  @media screen and (max-width: $tablet_start) {
    background: $color_second;
    height: $header_height_mobile;
    padding: 6px 6px 6px 10px;
  }
}

.user-info {
  position: relative;
  display: flex;
  flex-flow: row nowrap;
  align-items: center;
  justify-content: flex-end;
  cursor: pointer;
  width: 100%;
  // min-width: 190px;

  @media screen and (max-width: $tablet_start) {
    min-width: unset;
  }

  &__avatar {
    margin-right: 10px;

    @media screen and (max-width: $tablet_start) {
      margin-right: 0;
    }
  }

  &__username {
    color: $font_color_second;
    margin-right: 10px;

    @media screen and (max-width: $tablet_start) {
      display: none;
    }
  }

  &__icon {
    flex-shrink: 0;
    display: flex;
    justify-content: center;
    align-items: center;
    color: $font_color_third;
    transition: .3s;

    @media screen and (max-width: $tablet_start) {
      display: none;
    }
  }

  &__popup-menu {
    position: absolute;
    z-index: 99;
    left: auto;
    right: 0;
    top: calc(#{$header_height} + 10px);

    @media screen and (max-width: $tablet_start) {
      top: calc(#{$header_height_mobile} + 6px);
      width: 193px;
      left: 50%;
      transform: translateX(-50%);
    }
  }
}

.button-burger {
  width: 22px;
  height: 16px;
  display: flex;
  flex-direction: column;
  justify-content: space-between;
  cursor: pointer;

  &__line {
    display: block;
    height: 2px;
    background-color: #ffffff;
    transition: .3s;
  }

  &.active {
    .button-burger__line:first-child {
      transform: translate3d(0, 7px, 0) rotate(-45deg);
    }

    .button-burger__line:nth-child(2) {
      opacity: 0;
    }

    .button-burger__line:last-child {
      transform: translate3d(0, -7px, 0) rotate(45deg);
    }
  }
}

.fade-enter-active, .fade-leave-active {
  transition: opacity .3s;
}

.fade-enter, .fade-leave-to {
  opacity: 0;
}

.error__report {
  display: flex;
  align-items: center;
  cursor: pointer;
  color: $font_color_second;
  font-family: "Fira Sans", Arial, sans-serif;
  line-height: 19px;
  margin-right: 31px;
  transition: 0.2s;

  &:hover {
    color: #C01082;
  }
}
</style>
